import type { ProjectPhase } from "./projectPhase";

export interface TaskMessageDetail {
  type?: string;
  task_id?: string;
  target_id?: string;
  payload?: {
    task_id?: string;
    parent_task_id?: string;
    subtask_id?: string;
    comment_id?: string;
    phase?: ProjectPhase;
    workflow_action?: string;
    [key: string]: unknown;
  };
}

export function isTaskNodeMessage(type?: string) {
  return (
    type === "task.comment" ||
    type === "task.content.due" ||
    type === "task.assigned" ||
    type === "task.confirm" ||
    type === "task.status.change"
  );
}

export function isSubtaskReviewRequestMessage(
  detail?: TaskMessageDetail
) {
  return Boolean(
    detail?.type === "task.confirm" &&
      detail.payload?.workflow_action === "submit" &&
      detail.payload?.subtask_id
  );
}

export function getTaskMessageActionText(detail?: TaskMessageDetail) {
  if (isSubtaskReviewRequestMessage(detail)) {
    return "立即审核";
  }
  if (detail?.type === "task.comment") {
    return "查看批注节点";
  }
  if (detail?.type === "task.content.due") {
    return "查看到期任务";
  }
  if (
    detail?.type === "task.assigned" ||
    detail?.type === "task.status.change" ||
    detail?.type === "task.confirm"
  ) {
    return "查看任务节点";
  }
  return "查看项目节点图";
}

export function getTaskMessageFlowTarget(detail?: TaskMessageDetail) {
  if (!isTaskNodeMessage(detail?.type)) {
    return undefined;
  }
  return {
    taskId: detail?.payload?.task_id || detail?.task_id || detail?.target_id,
    parentTaskId: detail?.payload?.parent_task_id,
    subtaskId: detail?.payload?.subtask_id,
    commentId:
      detail?.type === "task.comment"
        ? detail?.payload?.comment_id
        : undefined,
    phase: detail?.payload?.phase,
  };
}
